import { ClassroomOverviewDTO } from "stores/classroomStore_I";
import { ClassroomSourceType } from "../../types/classrooms";

/*
Context: config gateway currently takes sourceId as the id for sourceTypes Google and Wonde.
To ensure compatibility, until we revisit chrome extension and agent, and update to use a more suitable identifier,
we need to align with the implementation in config gateway for these sourceTypes, see configurationgateway2/ums_transform.py
 */
export function getClassroomIdForChat(classroom?: ClassroomOverviewDTO): string | undefined {
	if (
		classroom?.sourceType?.toLowerCase() === ClassroomSourceType.Google ||
		classroom?.sourceType?.toLowerCase() === ClassroomSourceType.Wonde
	) {
		return classroom?.sourceId?.toLowerCase();
	} else {
		return classroom?.name;
	}
}
